import script from "./MenuCell.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCell.vue?vue&type=script&setup=true&lang=js"

import "./MenuCell.vue?vue&type=style&index=0&id=935ddd7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-935ddd7a"]])

export default __exports__